import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { createMarkup } from '../helpers';

function ProductListingListPriceBlock(props) {

  function getPastAmountBlockForComboKit() {
    let block = '';

    if (props.price.mainProductWasPrice && props.price.mainProductCurrentPrice) {
      block += `${props.translations.mainProductWasPriceTranslation} ` +
        `${props.price.mainProductWasPrice}, ` +
        `${props.translations.mainProductCurrentPriceTranslation} ` +
        `${props.price.mainProductCurrentPrice}.`;
    }

    if (props.price.separateSellingPrice) {
      block += `${block ? '\n' : ''}${props.translations.separateSellingPriceTranslation} ` +
        `${props.price.separateSellingPrice}`;
    }

    return block;
  }

  function getPastAmountBlockForNormalProduct() {
    const block = [];

    if (props.price.wasPrice) {
      block.push(
        <strong key={0}>
          {props.translations.wasPriceTranslation} {props.price.wasPrice}
        </strong>
      );
    }

    if (props.price.wasPriceFrom && props.price.wasPriceTo) {
      block.push(` (${props.translations.fromDateTranslation} ${props.price.wasPriceFrom} ` +
        `${props.translations.toDateTranslation} ${props.price.wasPriceTo})`);
    }

    return block;
  }

  return (
    <div
      className={`amounts ${props.isOutOfStock ? 'prd-oos' : ''}`}
    >
      {props.isFlashSale &&
        <p className="countdownSticker">
          <strong
            dangerouslySetInnerHTML={createMarkup(props.translations.countdownSaleTranslation)}
          />
        </p>
      }
      <div className="main-amount center border-t border-b">
        {props.isFlashSale &&
          <Fragment>
            <strong>{props.translations.webExclusivePriceTranslation}</strong>
            <br />
          </Fragment>
        }
        <strong className="price" data-product="price">
          {' '}{props.price.perMonthPrice
            ? props.price.perMonthPrice
            : props.price.price
          }{' '}
        </strong>
        {props.price.perMonthPrice &&
          <span className="per-month">
            <strong>{props.translations.perMonthTranslation}</strong>
          </span>
        }
        {props.price.savingsPrice &&
          <strong className="saving">
            {props.translations.savingsPriceTranslation} {props.price.savingsPrice}
          </strong>
        }
      </div>
      {props.price.inStorePrice &&
        <p>
          {props.translations.inStorePriceTranslation} {props.price.inStorePrice}
        </p>
      }
      <div className="past-amount desktop">
        {props.isComboKit ? getPastAmountBlockForComboKit() : getPastAmountBlockForNormalProduct()}
      </div>
    </div>
  );
}

ProductListingListPriceBlock.displayName = 'ProductListingListPriceBlock';

ProductListingListPriceBlock.propTypes = {
  isComboKit: PropTypes.bool.isRequired,
  isFlashSale: PropTypes.bool.isRequired,
  isOutOfStock: PropTypes.bool.isRequired,
  price: PropTypes.shape({
    price: PropTypes.string.isRequired,
    mainProductWasPrice: PropTypes.string,
    mainProductCurrentPrice: PropTypes.string,
    separateSellingPrice: PropTypes.string,
    wasPrice: PropTypes.string,
    savingsPrice: PropTypes.string,
    inStorePrice: PropTypes.string,
    wasPriceFrom: PropTypes.string,
    wasPriceTo: PropTypes.string,
    perMonthPrice: PropTypes.string
  }).isRequired,
  translations: PropTypes.shape({
    fromDateTranslation: PropTypes.string.isRequired,
    toDateTranslation: PropTypes.string.isRequired,
    mainProductWasPriceTranslation: PropTypes.string.isRequired,
    mainProductCurrentPriceTranslation: PropTypes.string.isRequired,
    separateSellingPriceTranslation: PropTypes.string.isRequired,
    wasPriceTranslation: PropTypes.string.isRequired,
    savingsPriceTranslation: PropTypes.string.isRequired,
    inStorePriceTranslation: PropTypes.string.isRequired,
    countdownSaleTranslation: PropTypes.string.isRequired,
    webExclusivePriceTranslation: PropTypes.string.isRequired,
    perMonthTranslation: PropTypes.string.isRequired
  }).isRequired
};

export default ProductListingListPriceBlock;
